import React, { Component } from "react";
import PropTypes from "prop-types";
import AppHelper from "../model/AppHelper";
import "../component/FlashcardItem.css";
import "./FlashcardVideo.css";

const getFlowPlayerKey = () => {
  return [
    "$863732616083910", // for localhost per https://flowplayer.org/i/flowplayer/setup:licence-for-localhost
    "$694570941863278", // talentedge.in
    "$715714643137655", // learntron.net
    "$157203594749916", // luckyinternationalschool.org
    "$546036332910781", // disprz.com,
    "$642768838741055" // myacademy.io
  ].join(", ");
};

export class FlashcardVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flowplayerInstance: null
    };
  }
  static propTypes = {
    pageItem: PropTypes.object.isRequired,
    isPageActive: PropTypes.bool,
    onLoadComplete: PropTypes.func
  };

  static defaultProps = {
    onLoadComplete: () => {}
  }

  componentDidMount() {
    const { pageItem, onLoadComplete } = this.props;
    const videoUrl = AppHelper.formatUrl(pageItem.getVideoUrl());
    if (videoUrl == "") {
      return;
    }
    let videoType = videoUrl
      .split("?")[0]
      .split(".")
      .pop()
      .toLowerCase();
    videoType =
      videoType == "m3u8" ? "application/x-mpegurl" : `video/${videoType}`;

    const sources = [{ type: videoType, src: videoUrl }];
    var playerId = `#flowplayerEl-${pageItem.pageItemId}`;
    const flowplayerInstance = window.flowplayer(playerId, {
      clip: {
        hlsjs: {
          safari: true
        },
        sources: sources
      },
      key: getFlowPlayerKey(),
      embed: false,
      share: false,
      keyboard: false
    });
    flowplayerInstance
    .on("play", this.checkAndToggleVideo.bind(this));
    this.setState({ flowplayerInstance });
    setTimeout(() => {
      onLoadComplete(pageItem, flowplayerInstance);
    }, 300);
  }

  componentWillUnmount() {
    this.state.flowplayerInstance.off(
      "play",
      this.checkAndToggleVideo.bind(this)
    );
  }

  checkAndToggleVideo() {
    const { isPageActive, flowplayerInstance } = this.state;
    if (!isPageActive && flowplayerInstance.playing) {
      flowplayerInstance.stop();
    }
  }

  render() {
    const itemContent = this.props.pageItem.getItemContent() || {};
    const style = !itemContent.thumbnailConsumableUrl ? {} : {
      backgroundImage: `url('${AppHelper.formatUrl(itemContent.thumbnailConsumableUrl)}')`
    };
    return (
      <div
        className={`flashcard-page-item ${
          this.props.pageItem.isVertical() ? "fullscreen" : ""
        }`}
      >
        <div
          style={style}
          className={
            "flowplayer fixed-controls no-toggle video-activity-element"
          }
          id={`flowplayerEl-${this.props.pageItem.pageItemId}`}
          ref="flowplayerRef"
        />
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { flowplayerInstance } = this.state;
    if (
      !nextProps.isPageActive &&
      flowplayerInstance &&
      flowplayerInstance.playing
    ) {
      flowplayerInstance.pause();
    }
  }
}

export default FlashcardVideo;
